module.exports = __webpack_public_path__ + "static/1-93916d6c96180d6c0fdee1085717863d.svg";